import { selectPage } from '../../selectors/analytics';
import { selectUser } from '../../selectors/user';
import { TThunkAction } from '../../types/redux/thunk';
import { trackCallbackClick, ICallbackClickValues } from '../../utils/analytics';

/**
 * Redux thunk action, отправляющий событие клика на "Заказать звонок" (успешный ответ от сервера)
 */
export const trackCallbackClickAction = (values: ICallbackClickValues): TThunkAction<void> => {
  return (dispatch, getState) => {
    const state = getState();
    const page = selectPage(state);
    const user = selectUser(state);

    trackCallbackClick({ page, user, values });
  };
};
